import {
  Children,
  createRef,
  forwardRef,
  Suspense,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import bookLetExplicitStyles from "./BookLet.module.css";
import { Button } from "reactstrap";
import { IoArrowBackOutline, IoArrowForwardOutline } from "react-icons/io5";
import { Canvas, useFrame, useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { AnimationMixer } from "three";
import PaperScroll from "./PaperScroll";
import { OrbitControls } from "@react-three/drei";
import ThreeJSDefaultLoader from "./ThreeJSDefaultLoader";
import { useSelector } from "react-redux";
import { AiOutlineFullscreen } from "react-icons/ai";

const BookLet = ({ children, pageBackground, title }) => {
  const allChildren = Children.map(children, (c) => c);
  const user = useSelector((s) => s?.user ?? {});
  const [activeIndex, setActiveIndex] = useState(0);
  const bookletReference = useRef();

  const goForward = () => {
    if (activeIndex == allChildren?.length - 1) setActiveIndex(0);
    else setActiveIndex((prev) => prev + 1);
  };
  const goBack = () => {
    if (activeIndex <= 0) setActiveIndex(0);
    else setActiveIndex((prev) => prev - 1);
  };
  const goTo = (index) => {
    setActiveIndex(index);
  };

  return (
    <div
      className={bookLetExplicitStyles.wrapper}
      // style={{
      //   background: `url(${pageBackground})`,
      // }}
      ref={bookletReference}
    >
      <div
        className={` full-width  px-1 
       ${bookLetExplicitStyles.adjustable_max}
          `}
      >
        <div
          className={`${bookLetExplicitStyles?.page}`}
          // when flow at special-event show bg
        >
         
            <h2 className="resturant-title mb-2 mt-3 text-center">{title}</h2>
      

          {allChildren[activeIndex]}
        </div>
      </div>

      <div
        style={{ width: "100%" }}
        className={`d-flex  px-3  align-items-center justify-content-between ${bookLetExplicitStyles?.adjustable_max}`}
      >
        <Button
          onClick={() => goBack()}
          className="border-none bg-transparent text-black"
        >
          <IoArrowBackOutline size={30} />
        </Button>
        <div>
          {allChildren?.map((i, index) => (
            <Button
              key={`navi-${index}`}
              onClick={() => goTo(index)}
              className="p-0 mx-2 carousel-button"
            ></Button>
          ))}
        </div>
        <Button
          onClick={() => goForward()}
          className="border-none bg-transparent text-black"
        >
          <IoArrowForwardOutline size={30} />
        </Button>
      </div>
    </div>
  );
};

export default BookLet;
